import { Injectable } from '@angular/core';


@Injectable()
export class AuthService {
  constructor() {}

  // Facebook login
  doFacebookLogin() {
    return null;
  }

  // Github login
  doGitHubLogin() {
    return null;
  }

  // Twitter login
  doTwitterLogin() {
    return null;
  }

  // Google login
  doGoogleLogin() {
    return null;
  }

  // Register
  doRegister(value) {
    return null;
  }

  // Login
  doLogin(value) {
    return null;
  }

  // Logout
  doLogout() {
    return null;
  }
}
